import { render } from "./designCheckboxPreview.vue?vue&type=template&id=b71f5018&scoped=true"
import script from "./designCheckboxPreview.vue?vue&type=script&lang=js"
export * from "./designCheckboxPreview.vue?vue&type=script&lang=js"

import "./designCheckboxPreview.vue?vue&type=style&index=0&id=b71f5018&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71f5018"]])

export default __exports__